import React from 'react';
import { IQueryContext } from 'framework/context/IQueryContext';
import { IPatientsQueryParams, IPatientSummary, IQueryResult } from 'gen/ApiClient';

export const PatientsQueryContext = React.createContext<IQueryContext<IQueryResult<IPatientSummary>, IPatientsQueryParams>>(undefined as any);
